import React from "react";

export default function RenewalComponent() {
  return (
    <div className="about_area pt-45">
      <div className="container">
        <div className="row">
          

          {/* Text Content Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="section_title text_left mb-40 mt-3">
              
              <div className="section_main_title text-left">
                <h1>Prioritize Key Accounts with Refreshed
              
                <span> Renewal Intelligence.</span>
                </h1>
              </div>
              <div className="em_bar">
                <div className="em_bar_bg"></div>
              </div>
              
            </div>

            <div className="singel_about_left mb-30">
              <div className="singel_about_left_inner mb-3">
                <div className="singel-about-content text-left">
                  <p>
                  <b>Most Technology Buying Decisions Start Months Before the Renewal Date.</b> <br/>When enterprise software contracts approach renewal, buyers quietly reassess their vendors, pricing, and technology stack. For revenue teams that know the timing, these moments become high-probability opportunities.</p>
                  <p><b>ProPlus Data Renewal Intelligence reveals upcoming technology contract renewals across your target accounts.</b> Identify expiring software, SaaS, and enterprise technology contracts, track vendor relationships, and understand renewal timelines so your team can engage buyers while they are actively evaluating alternatives.</p>
                  <p>Start conversations earlier, position your solution at the right moment, and turn renewal cycles into a predictable pipeline.</p>
                 
                </div>
              </div>

              
            </div>
          </div>
          {/* Image Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="about_thumb">
              <img src="/assets/images/renewal-and-subscription.gif" alt="renewal & Subscription insights" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
